/**
 * G2eGente - Rodapé de Versão do App
 * Exibe versão atual instalada e versão disponível no servidor
 */
import React, { useState, useEffect } from 'react';
import { RefreshCw, Download, CheckCircle2 } from 'lucide-react';

// Versão do app instalado (atualizar a cada release)
const APP_VERSION = '2.4.0';

export default function AppVersionFooter() {
  const [serverVersion, setServerVersion] = useState(null);
  const [loading, setLoading] = useState(false);
  const [hasUpdate, setHasUpdate] = useState(false);

  useEffect(() => {
    checkVersion();
    // Verificar a cada 60 segundos
    const interval = setInterval(checkVersion, 60000);
    return () => clearInterval(interval);
  }, []);

  const checkVersion = async () => {
    try {
      const response = await fetch('/api/version', {
        cache: 'no-store',
        headers: { 'Cache-Control': 'no-cache' }
      });
      if (response.ok) {
        const data = await response.json();
        setServerVersion(data.version);
        setHasUpdate(data.version !== APP_VERSION);
      }
    } catch (error) {
      console.log('[Version] Erro ao verificar versão:', error);
    }
  };

  const handleUpdate = async () => {
    setLoading(true);
    try {
      // Limpar caches
      if ('caches' in window) {
        const cacheNames = await caches.keys();
        await Promise.all(cacheNames.map(name => caches.delete(name)));
      }
      
      // Remover service workers
      if ('serviceWorker' in navigator) {
        const registrations = await navigator.serviceWorker.getRegistrations();
        await Promise.all(registrations.map(r => r.unregister()));
      }
      
      // Recarregar
      window.location.reload(true);
    } catch (error) {
      console.error('[Version] Erro ao atualizar:', error);
      window.location.reload(true);
    }
  };

  return (
    <div className="mt-6 mb-4 mx-4" data-testid="app-version-footer">
      <div className="bg-slate-100 rounded-xl p-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className={`w-2 h-2 rounded-full ${hasUpdate ? 'bg-amber-500 animate-pulse' : 'bg-green-500'}`} />
            <span className="text-xs text-slate-500">
              v{APP_VERSION}
              {serverVersion && serverVersion !== APP_VERSION && (
                <span className="text-amber-600 ml-1">→ v{serverVersion}</span>
              )}
            </span>
          </div>
          
          {hasUpdate ? (
            <button
              onClick={handleUpdate}
              disabled={loading}
              className="flex items-center gap-1 text-xs text-cyan-600 hover:text-cyan-700 font-medium"
              data-testid="update-app-btn"
            >
              {loading ? (
                <RefreshCw className="w-3 h-3 animate-spin" />
              ) : (
                <Download className="w-3 h-3" />
              )}
              {loading ? 'Atualizando...' : 'Atualizar'}
            </button>
          ) : (
            <span className="flex items-center gap-1 text-xs text-green-600">
              <CheckCircle2 className="w-3 h-3" />
              Atualizado
            </span>
          )}
        </div>
      </div>
    </div>
  );
}

// Exportar versão para uso em outros lugares
export { APP_VERSION };
